<template>
    <m-main-layout>
        <div class="page-content-main">
            <el-form
                :model="formData"
                status-icon
                :rules="rules"
                ref="form"
                label-width="auto"
                class="margin-top"
                style="width:800px;"
            >
	            <el-form-item label="测试模版消息">
		            <el-input v-model="openid" placeholder="请输入用户小程序openid" style="width:300px;"></el-input>
		            <el-button class="margin-left" type="primary" @click="toSendTestMsg">发送</el-button>
	            </el-form-item>
                <el-form-item label="小程序APPID" prop="weixin_mini_app_id">
                    <el-input v-model="formData.weixin_mini_app_id" style="width:300px;">
                    </el-input>
                </el-form-item>
                <el-form-item label="小程序AppSecret" prop="weixin_mini_app_secret">
                    <el-input v-model="formData.weixin_mini_app_secret" style="width:300px;">
                    </el-input>
                </el-form-item>
                <el-form-item label="小程序二维码" prop="weixin_mini_app_qrcode">
                    <head-img-upload v-model="formData.weixin_mini_app_qrcode"></head-img-upload>
                </el-form-item>
                <el-form-item label="平台服务协议" prop="weixin_mini_service">
                    <el-input type="textarea" :rows="8" placeholder="请输入内容" v-model="formData.weixin_mini_service" style="width: 600px;"></el-input>
                </el-form-item>
	            <el-form-item label="隐私协议" prop="weixin_mini_secret">
		            <el-input type="textarea" :rows="8" placeholder="请输入内容" v-model="formData.weixin_mini_secret" style="width: 600px;"></el-input>
	            </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('form')">确定</el-button>
                    <el-button type="" @click="$router.back()">返回</el-button>
                </el-form-item>
            </el-form>
        </div>
    </m-main-layout>
</template>

<script>
export default {
    name: "add",
    data() {
        return {
	        openid:'',
            formData: {
                weixin_mini_app_id: "",
                weixin_mini_app_secret: "",
                weixin_mini_app_qrcode:'',
	            weixin_mini_service:'',
	            weixin_mini_secret:''
            },
            rules: {
                weixin_mini_app_id: [{required: true,message:'appid必填'}],
                weixin_mini_app_secret: [{required: true,message:'appSecret必填'}],
	            weixin_mini_service: [{required: true,message:'服务协议必填'}],
	            weixin_mini_secret: [{required: true,message:'隐私协议必填'}],
                // weixin_mini_app_qrcode: [{required: true,message:'小程序二维码必填'}],
            }
        };
    },
    mounted() {
        this.getDetail();
    },
    methods: {
        submitForm(formName) {
            let _this = this;
            console.log(_this.formData);
            this.$refs[formName].validate(valid => {
                if (valid) {
                    _this.$http.httpPost({
                        url: "/SystemSetting/edit",
                        datas: {..._this.formData},
                        success: res => {
                            if (res === "ok") {
                                _this.$message.success("修改成功");
                            } else {
                                _this.$message.error("修改失败");
                            }
                            // _this.$message.info(res.msg);
                            // _this.$router.replace({path: '/cate/list'})
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        getDetail() {
            let _this = this;

            let _skeys = [];

            for (let k in this.formData) {
                _skeys.push(k);
            }

            _this.$http.httpPost({
                url: "/SystemSetting/getSystem",
                datas: {skey: _skeys},
                success: res => {
                    _this.formData = res;
                }
            });
        },
	    toSendTestMsg(){
		    let _this = this;
				
				if(!this.openid){
					this.$message.error('请输入用户小程序openid')
					return;
				}
		
		    _this.$http.httpPost({
			    url: "/SystemSetting/sendTestTemMsg",
			    datas: {openid: this.openid},
			    success: res => {
				    _this.$message.success('发送成功');
			    }
		    });
	    }
    }
};
</script>
